import axios from 'axios'

export default axios.create({
  baseURL: 'https://official-api.hsmap.com',
  timeout: 5000,
});


// WEBPACK FOOTER //
// ./src/utils/http.js